import {
  dynamicElementsMediaPreview,
  dynamicElementsProductCardKey,
} from '@epicuro-next/constants/dynamic-elements';
import { FancyListItem, List, Media } from '@epicuro-next/models/engagement';
import { filterArray, isNonNullish } from '@epicuro-next/utilities';

import { isPowerList } from './index';

export function layoutToItems(list: List): FancyListItem[] {
  try {
    if (list.layout) {
      return JSON.parse(list.layout as string);
    }

    return [];
  } catch {
    return [];
  }
}

export const isItemOfType =
  (contentTypeId: string) => (item: FancyListItem) => {
    return (
      item.content.contentTypeId.toLowerCase() === contentTypeId.toLowerCase()
    );
  };

export const isProductItem = isItemOfType(dynamicElementsProductCardKey);
export const isMediaItem = isItemOfType(dynamicElementsMediaPreview);

export function getPromoteAvailableMediaItems(list: List) {
  function formatter(item: Media) {
    return [item.name, item.url.replace(/\?.*/, '')].join('_');
  }

  if (isPowerList(list)) {
    const items = layoutToItems(list);
    const medias = items
      .filter(isMediaItem)
      .map((item) => {
        return item.content.payload.media;
      })
      .filter(isNonNullish);
    const listMedia = list.mainMedia ?? list.media?.[0];
    if (listMedia && !medias.some((m) => m.url === listMedia.url)) {
      medias.unshift(listMedia);
    }

    return filterArray(medias, formatter);
  }

  return [];
}
